function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "d8fe06tnma",
  width: 131,
  height: 125,
  x: 20,
  y: 18,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20 18.106h130.565v124.821H20V18.106z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#d8fe06tnma)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  d: "M150.565 106.952V54.101L85.221 90.049v52.878l65.344-35.975z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M85.221 90.049l-34.1-26.43-31.206-7.317v50.671l8.726 4.795 3.11-2.062 39.876 21.974v3.777l13.594 7.468V90.049zM19.915 54.066l30.627 7.972 65.325-35.96-30.646-7.972-65.306 35.96z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  d: "M50.542 62.038l65.325-35.96L150.565 54.1 85.221 90.049 50.542 62.038zM31.75 109.706l39.877 21.974V96.587L31.75 74.642v35.064z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M131.451 72.651l-13.558 7.46v6.37l13.558-7.465v-6.365z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M131.451 79.828l-2.445-1.012-11.113 6.13v2.373l13.558-7.491z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M131.451 79.828l-2.445-1.012V74l2.445-1.349v7.177z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  d: "M147.626 63.733l-13.557 7.462v6.37l13.557-7.465v-6.366z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M147.626 70.91l-2.445-1.01-11.112 6.128v2.374l13.557-7.492z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M147.626 70.91l-2.445-1.01v-4.818l2.445-1.348v7.176z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  d: "M32.061 74.792l-3.42-1.883v38.859l3.42-1.879V74.792zM49.107 80.131s-1.61.702-2.383 3.488c.108.076.225.15.362.22 2.7 1.413 4.394.744 4.394.744.045-2.335-.623-3.643-2.373-4.452z"
}));

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "v8qc2eomab",
  width: 66,
  height: 39,
  x: 20,
  y: 54,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20 54.066h65.221V92.34H20V54.066z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#v8qc2eomab)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M49.107 80.131c-2.5-1.156-3.256 1.412-3.256 1.412s-.429 1.179.873 2.076c.774-2.786 2.383-3.488 2.383-3.488z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  d: "M19.915 54.066v2.32l30.58 8.502L85.221 92.34v-2.291L50.542 62.038l-30.627-7.972z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M85.22 90.049v2.29l65.345-35.97V54.1L85.221 90.049z"
}));

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "wob1q0os2c",
  width: 66,
  height: 40,
  x: 20,
  y: 103,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20 103.206h65.221v39.719H20v-39.719z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#wob1q0os2c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  d: "M28.64 111.767v-3.756l-8.725-4.805v3.767l8.726 4.794z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M32.061 106.135l-3.42 1.876v3.757l3.42-1.879v-3.754zM32.061 81.7v.652l39.566 21.79v-.661L32.061 81.699zM32.061 84.084v.655l39.566 21.79v-.663L32.061 84.084zM32.061 86.538v.653l39.566 21.79v-.661L32.061 86.538zM32.061 88.924v.653l39.566 21.789v-.661l-39.566-21.78zM32.061 91.442v.652l39.566 21.79v-.661l-39.566-21.78zM32.061 93.826v.654l39.566 21.79v-.662L32.061 93.826zM32.061 96.168v.653l39.566 21.79v-.661L32.061 96.168zM32.061 98.553v.653l39.566 21.79v-.661L32.061 98.553zM32.061 101.071v.653l39.566 21.79v-.661l-39.566-21.782zM32.061 103.456v.654l39.566 21.79v-.662l-39.566-21.782z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  d: "M32.061 105.842v.653l39.566 21.789v-.661l-39.566-21.781zM32.061 108.242v.653l39.566 21.79v-.661l-39.566-21.782z"
}));

function SvgSpaceStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 162,
    fill: "none",
    viewBox: "0 0 170 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceStorage);
export default __webpack_public_path__ + "static/media/spaceStorage.f1be809d.svg";
export { ForwardRef as ReactComponent };